var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noticeWarp"},[_c('div',{staticClass:"close",on:{"click":_vm.closeMenu}},[_vm._v("×")]),_c('img',{attrs:{"src":_vm.imgUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }